export const RightArrow: React.FC<{ mode: Boolean }> = ({ mode }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.75 9.33366V9.33366L10.5833 5.16699C10.25 4.83366 9.75 4.83366 9.41667 5.16699C9.08333 5.50033 9.08333 6.00033 9.41667 6.33366L12.1667 9.08366H5.83333C5.33333 9.08366 5 9.41699 5 9.91699C5 10.417 5.33333 10.7503 5.83333 10.7503H12.1667L9.41667 13.5003C9.08333 13.8337 9.08333 14.3337 9.41667 14.667C9.75 15.0003 10.25 15.0003 10.5833 14.667V14.667L14.75 10.5003C15.0833 10.2503 15.0833 9.66699 14.75 9.33366Z"
        fill={mode ? 'black' : 'white'}
      />
    </svg>
  )
}

export default RightArrow
